import React from "react";
import { withRouter } from "react-router-dom";
import hamburgerIcon from "../../images/global-menu/global-menu-icon-hl.webp";
import arrowLeftIcon from "../../images/ppv/arrow-left.webp";

const styleType = {
  contact:       { style: "light-back", backUrl: false,               title: "Contact" },
  edit:          { style: "light-back", backUrl: "/account?screen=overview", title: "Edit" },
  delete:        { style: "light-back", backUrl: "/account?screen=overview", title: "Delete Account" },
  account:       { style: "light-back", backUrl: false,               title: "Account" },
  overview:      { style: "light-back", backUrl: "/account",          title: "Account Overview" },
  plans:         { style: "light-back", backUrl: "/account",          title: "Plans" },
  presale:       { style: "light-back", backUrl: "/account",          title: "Pre-Sale Tickets" },
  tickets:       { style: "light-back", backUrl: "/account",          title: "Pre-Sale Tickets" },
  notifications: { style: "light-back", backUrl: "/account",          title: "Notification Settings" },
  subscription:  { style: "light-back", backUrl: "/account",          title: "Subscription" },
  subject:       { style: "light-back", backUrl: "/contact",          title: "Subject" },
  about:         { style: "light-back", backUrl: false,               title: "About" },
  terms:         { style: "light-back", backUrl: "goBack",            title: "Terms and Conditions" },
  privacy:       { style: "light-back", backUrl: "goBack",            title: "Privacy Policy" },
  credits:       { style: "light-back", backUrl: "goBack",            title: "Credits" },
};

const ResponsiveNavbar = ({ history, sidebarOpen, onToggleSidebar, pathOverride }) => {
  const pathname = history.location.pathname;
  const segments = pathname.split("/").filter(Boolean);
  const detectedPath = segments[segments.length - 1] || "";
  const path = pathOverride || detectedPath;

  // News article pages: show back arrow to the news page list
  const isNewsArticle = pathname.includes("/news/") && pathname.includes("/article");
  const newsPage = segments.length >= 2 && segments[0] === "news" ? segments[1] : "1";

  const info = isNewsArticle
    ? { style: "regular", backUrl: `/news/${newsPage}`, title: false }
    : (styleType[path] || {});
  const { style = "regular", title = false, backUrl = false } = info;

  const isLight = style === "light-back";
  const showBackArrow = isLight;

  const handleClick = () => {
    if (backUrl === "goBack") {
      history.goBack();
    } else if (backUrl) {
      history.push(backUrl);
    } else {
      onToggleSidebar();
    }
  };

  const handlePress = (event) => {
    if (event.type === "click" && event.detail > 0) return;
    handleClick();
  };

  return (
    <div className={`responsive-navbar ${isLight ? "light-back" : ""}`}>
      <button
        type="button"
        className="responsive-navbar-btn"
        onPointerUp={handlePress}
        onClick={handlePress}
      >
        <img
          src={showBackArrow ? arrowLeftIcon : hamburgerIcon}
          alt={showBackArrow ? "back" : "menu"}
        />
      </button>
      <div className="responsive-navbar-title">
        {title ? (
          <span>{title}</span>
        ) : (
          <div className="responsive-navbar-logo" />
        )}
      </div>
    </div>
  );
};

export default withRouter(ResponsiveNavbar);
